import Vue from 'vue'
import Router from 'vue-router'


const companyIndex = () => import('@/pages/home/CompanyIndex.vue');
const prodDetails = () => import('@/pages/prod/ProdDetails.vue');
const HrDetails = () => import('@/pages/details/HrDetails.vue');
const companyAction = () => import('@/pages/details/NewsDetails.vue');

Vue.use(Router)

export default new Router({
  mode:"history",
  routes: [
    {
      path: '*',
      name: 'error404',
      component: resolve => require(['@/pages/error-page/404'], resolve)
    },
    {
      path: '/502',
      name: 'error502',
      component: () => import('@/pages/error-page/502')
    },
    {
      path: '/companyHome',
      name: '企业首页',
      component: companyIndex,
      meta: {
        keepAlive:true
      }
    },
    {
      path: '/prodDetails',
      name: '产品详情',
      component: prodDetails
    }, {
      path: '/companyAction',
      name: '新闻详情',
      component: companyAction
    }, {
      path: '/HrDetails',
      name: '招聘详情',
      component: HrDetails
    },
  ],
  scrollBehavior (to, from, savedPosition) {
    // savedPosition 会在你使用浏览器前进或后退按钮时候生效
    // 这个跟你使用 router.go() 或 router.back() 效果一致
    // 这也是为什么我在 tab 栏结构中放入了一个 点击回退 的按钮
    if (savedPosition) {
      return savedPosition
    } else {
      // 如果不是通过上述行为切换组件，就会让页面回到顶部
      return {x: 0, y: 0}
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js